/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGScreen(props) {
  return (
    <svg width={83} height={110} viewBox="0 0 83 110" {...props}>
      <g>
        <path
          d="M42.486 44.671c-.788-.315-2.184-.315-2.971 0l-28.322 11.329h59.615l-28.322-11.329zm-3.714-1.857c1.264-.506 3.192-.506 4.457 0l37.964 15.186h-80.385l37.964-15.186z"
          fill="#00A1DE"
        />
        <g>
          <path
            d="M43 36c0 1.105-.895 2-2 2-1.657 0-3 1.343-3 3s1.343 3 3 3c1.428 0 2.651-1.006 2.937-2.384.225-1.081 1.284-1.776 2.365-1.551 1.081.225 1.776 1.284 1.551 2.365-.671 3.224-3.521 5.57-6.853 5.57-3.866 0-7-3.134-7-7 0-3.171 2.109-5.85 5-6.71v-19.29h4v21z"
            id="Combined-Shape"
            fill="#E6F5FB"
          />
          <path
            d="M40 35.036l-.715.213c-2.522.751-4.285 3.079-4.285 5.752 0 3.314 2.686 6 6 6 2.846 0 5.298-2 5.874-4.773.112-.541-.235-1.07-.775-1.183-.541-.112-1.07.235-1.183.775-.384 1.847-2.02 3.18-3.916 3.18-2.209 0-4-1.791-4-4s1.791-4 4-4c.552 0 1-.448 1-1v-20h-2v19.036zm-2-21.036h6v22c0 1.657-1.343 3-3 3-1.105 0-2 .895-2 2s.895 2 2 2c.948 0 1.767-.667 1.958-1.588.337-1.622 1.926-2.664 3.548-2.326 1.622.337 2.664 1.926 2.326 3.548-.769 3.7-4.038 6.366-7.832 6.366-4.418 0-8-3.582-8-8 0-3.305 2.022-6.215 5-7.418v-19.582z"
            id="Combined-Shape"
            fill="#00A1DE"
          />
          <g id="Group-4" transform="translate(35 27)">
            <rect
              id="Rectangle-31"
              fill="#97D9F2"
              x={1}
              y={1}
              width={10}
              height={4}
              rx={1}
            />
            <path
              d="M1.995 2l.005.009v1.981l-.002.009h8.006l-.005-.009v-1.981l.002-.009h-8.006zm-1.995.009c0-1.105.898-2.009 1.995-2.009h8.009c1.107 0 1.995.896 1.995 2.009v1.981c0 1.105-.898 2.009-1.995 2.009h-8.009c-1.107 0-1.995-.896-1.995-2.009v-1.981z"
              id="Rectangle-31"
              fill="#00A1DE"
            />
          </g>
          <g transform="translate(35 14)">
            <rect
              id="Rectangle-31"
              fill="#97D9F2"
              x={1}
              y={1}
              width={10}
              height={4}
              rx={1}
            />
            <path
              d="M1.995 2l.005.009v1.981l-.002.009h8.006l-.005-.009v-1.981l.002-.009h-8.006zm-1.995.009c0-1.105.898-2.009 1.995-2.009h8.009c1.107 0 1.995.896 1.995 2.009v1.981c0 1.105-.898 2.009-1.995 2.009h-8.009c-1.107 0-1.995-.896-1.995-2.009v-1.981z"
              fill="#00A1DE"
            />
          </g>
        </g>
        <path
          d="M41 44.435c.573 0 1.115.088 1.486.236l33.143 13.257c.513.205 1.095-.044 1.3-.557.205-.513-.044-1.095-.557-1.3l-33.143-13.257c-.628-.251-1.418-.379-2.228-.379-.552 0-1 .448-1 1s.448 1 1 1z"
          id="Combined-Shape"
          fill="#00A1DE"
        />
      </g>
      <g transform="translate(0 53)">
        <rect
          id="Rectangle-25"
          fill="#fff"
          x={1}
          y={1}
          width={80}
          height="53.333"
          rx={2}
        />
        <path
          d="M74 1h5.003c1.103 0 1.997.903 1.997 1.993v49.347c0 1.101-.898 1.993-1.997 1.993h-76.005c-1.103 0-1.997-.903-1.997-1.993v-5.007h71.003c1.099 0 1.997-.892 1.997-1.993v-44.34z"
          id="Combined-Shape"
          fill="#E6F5FB"
        />
        <path
          d="M1 3c0-1.105.898-2 1.997-2h76.005c1.103 0 1.997.899 1.997 2v4.666h-80v-4.666z"
          fill="#97D9F2"
        />
        <path
          d="M5 5.667c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm5.333 0c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm5.333 0c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333z"
          id="Combined-Shape"
          fill="#CBECF9"
        />
        <path
          d="M50.195 18.807c.391.39.391 1.024 0 1.414-.39.391-1.024.391-1.414 0-1.106-1.105-2.41-1.952-3.842-2.5-.516-.197-.774-.775-.577-1.291.197-.516.775-.774 1.291-.577 1.695.648 3.237 1.65 4.541 2.953zm-9.877-3.79c-1.838.094-3.615.57-5.235 1.399-.492.252-.686.854-.435 1.346.252.492.854.686 1.346.435 1.368-.7 2.87-1.102 4.426-1.182.552-.028.976-.498.947-1.05-.028-.552-.498-.976-1.05-.947zm-9.428 4.804c-1.159 1.429-1.989 3.073-2.455 4.832-.141.534.177 1.081.71 1.223.534.141 1.081-.177 1.223-.71.394-1.487 1.096-2.876 2.075-4.085.348-.429.282-1.059-.147-1.407-.429-.348-1.059-.282-1.407.147zm-2.722 10.272c.291 1.799.956 3.52 1.964 5.05.304.461.924.589 1.385.285.461-.304.589-.924.285-1.385-.852-1.293-1.414-2.748-1.66-4.27-.088-.545-.602-.916-1.147-.827-.545.088-.916.602-.827 1.147zm5.765 8.825c1.533.995 3.254 1.651 5.065 1.929.546.084 1.056-.291 1.14-.837.084-.546-.291-1.056-.837-1.14-1.532-.235-2.985-.789-4.28-1.63-.463-.301-1.083-.169-1.383.294-.301.463-.169 1.083.294 1.383zm10.461 1.637c1.761-.473 3.399-1.313 4.822-2.475.428-.349.491-.979.142-1.407-.349-.428-.979-.491-1.407-.142-1.203.983-2.587 1.693-4.075 2.092-.533.143-.85.692-.706 1.225.143.533.692.85 1.225.706zm8.213-6.688c.823-1.631 1.29-3.417 1.377-5.239.026-.552-.399-1.02-.951-1.047-.552-.026-1.02.399-1.047.951-.074 1.543-.469 3.054-1.165 4.433-.249.493-.051 1.094.442 1.343.493.249 1.094.051 1.343-.442zm.499-10.612c.201.514-.053 1.094-.567 1.295-.514.201-1.094-.053-1.295-.567-.547-1.4-1.378-2.676-2.463-3.761-.391-.39-.391-1.024 0-1.414.39-.391 1.024-.391 1.414 0 1.282 1.281 2.265 2.792 2.912 4.448zm-13.852 8.272l.03-.022-.03.022zm.775-.023l.027.019-.027-.019zm.197.256l.002.003-.029-.05.027.047zm-.027-.047l-.047-.06.047.06zm-1.278-1.088l6.207-6.764 1.474 1.352-6.943 7.566-.737-.803-2.712-2.956c.215.233.586.246.818.024.22-.21.231-.554.025-.778l3.029 3.301-.108-.095-.079-.065.066.052.073.062.035.03.083.101-.083-.095-.035-.036-.051-.043-.077-.05.045.025.06.038-.037-.018-.094-.048-.222-.043-.223.043-.099.051-.034.018.067-.044.037-.021-.07.046-.092.081-.157.205.159-.211.217-.168-.227.184 6.52-7.105c-.205.224-.194.568.027.779.231.221.601.208.816-.025l-1.47-1.357c.541-.586 1.455-.617 2.034-.065.567.542.597 1.441.066 2.02l-6.544 7.13-.026.022-.022.026-.233.172-.201.109c-.172.071-.356.11-.546.11-.19 0-.374-.039-.546-.111l-.2-.108c-.087-.049-.15-.092-.238-.177l-.028-.032.058.05-.065-.058-.031-.028-3.028-3.3c-.53-.578-.501-1.477.066-2.02.579-.552 1.493-.521 2.036.068l2.714 2.957h-1.474z"
          id="Combined-Shape"
          fill="#97D9F2"
        />
        <path
          d="M2 2.993v49.347c0 .542.451.993.997.993h76.005c.549 0 .997-.447.997-.993v-49.347c0-.542-.451-.993-.997-.993h-76.005c-.549 0-.997.447-.997.993zm-2 0c0-1.653 1.346-2.993 2.997-2.993h76.005c1.652 0 2.997 1.348 2.997 2.993v49.347c0 1.653-1.346 2.993-2.997 2.993h-76.005c-1.652 0-2.997-1.348-2.997-2.993v-49.347zm80 .007c0-.551-.448-1-.997-1h-76.005c-.548 0-.997.449-.997 1v3.666h78v-3.666zm-80 0c0-1.656 1.345-3 2.997-3h76.005c1.655 0 2.997 1.346 2.997 3v5.666h-82v-5.666z"
          fill="#00A1DE"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGScreen.js